
export interface CountryData {
  code: string;
  name: string;
  flag: string;
  countryCode?: string;
  pattern: string;
  maxLength: number;
  format: (digits: string) => string;
}

export const COUNTRY_CODES: Record<string, CountryData> = {
  '1': {
    code: '+1',
    name: 'US/Canada',
    flag: '🇺🇸',
    countryCode: 'us',
    pattern: '+1 (XXX) XXX-XXXX',
    maxLength: 11,
    format: (digits: string) => {
      if (digits.length <= 1) return `+${digits}`;
      if (digits.length <= 4) return `+${digits.slice(0, 1)} (${digits.slice(1)}`;
      if (digits.length <= 7) return `+${digits.slice(0, 1)} (${digits.slice(1, 4)}) ${digits.slice(4)}`;
      return `+${digits.slice(0, 1)} (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 11)}`;
    }
  },
  '44': {
    code: '+44',
    name: 'United Kingdom',
    flag: '🇬🇧',
    countryCode: 'gb',
    pattern: '+44 XX XXXX XXXX',
    maxLength: 13,
    format: (digits: string) => {
      if (digits.length <= 2) return `+${digits}`;
      if (digits.length <= 4) return `+${digits.slice(0, 2)} ${digits.slice(2)}`;
      if (digits.length <= 8) return `+${digits.slice(0, 2)} ${digits.slice(2, 4)} ${digits.slice(4)}`;
      return `+${digits.slice(0, 2)} ${digits.slice(2, 4)} ${digits.slice(4, 8)} ${digits.slice(8, 13)}`;
    }
  },
  '49': {
    code: '+49',
    name: 'Germany',
    flag: '🇩🇪',
    countryCode: 'de',
    pattern: '+49 XXX XXXXXXXX',
    maxLength: 14,
    format: (digits: string) => {
      if (digits.length <= 2) return `+${digits}`;
      if (digits.length <= 5) return `+${digits.slice(0, 2)} ${digits.slice(2)}`;
      return `+${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5, 14)}`;
    }
  },
  '33': {
    code: '+33',
    name: 'France',
    flag: '🇫🇷',
    countryCode: 'fr',
    pattern: '+33 X XX XX XX XX',
    maxLength: 12,
    format: (digits: string) => {
      if (digits.length <= 2) return `+${digits}`;
      if (digits.length <= 3) return `+${digits.slice(0, 2)} ${digits.slice(2)}`;
      if (digits.length <= 5) return `+${digits.slice(0, 2)} ${digits.slice(2, 3)} ${digits.slice(3)}`;
      if (digits.length <= 7) return `+${digits.slice(0, 2)} ${digits.slice(2, 3)} ${digits.slice(3, 5)} ${digits.slice(5)}`;
      if (digits.length <= 9) return `+${digits.slice(0, 2)} ${digits.slice(2, 3)} ${digits.slice(3, 5)} ${digits.slice(5, 7)} ${digits.slice(7)}`;
      return `+${digits.slice(0, 2)} ${digits.slice(2, 3)} ${digits.slice(3, 5)} ${digits.slice(5, 7)} ${digits.slice(7, 9)} ${digits.slice(9, 12)}`;
    }
  },
  '86': {
    code: '+86',
    name: 'China',
    flag: '🇨🇳',
    countryCode: 'cn',
    pattern: '+86 XXX XXXX XXXX',
    maxLength: 14,
    format: (digits: string) => {
      if (digits.length <= 2) return `+${digits}`;
      if (digits.length <= 5) return `+${digits.slice(0, 2)} ${digits.slice(2)}`;
      if (digits.length <= 9) return `+${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5)}`;
      return `+${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5, 9)} ${digits.slice(9, 14)}`;
    }
  },
  '81': {
    code: '+81',
    name: 'Japan',
    flag: '🇯🇵',
    countryCode: 'jp',
    pattern: '+81 X-XXXX-XXXX',
    maxLength: 13,
    format: (digits: string) => {
      if (digits.length <= 2) return `+${digits}`;
      if (digits.length <= 3) return `+${digits.slice(0, 2)} ${digits.slice(2)}`;
      if (digits.length <= 7) return `+${digits.slice(0, 2)} ${digits.slice(2, 3)}-${digits.slice(3)}`;
      return `+${digits.slice(0, 2)} ${digits.slice(2, 3)}-${digits.slice(3, 7)}-${digits.slice(7, 13)}`;
    }
  },
  '91': {
    code: '+91',
    name: 'India',
    flag: '🇮🇳',
    countryCode: 'in',
    pattern: '+91 XXXXX XXXXX',
    maxLength: 13,
    format: (digits: string) => {
      if (digits.length <= 2) return `+${digits}`;
      if (digits.length <= 7) return `+${digits.slice(0, 2)} ${digits.slice(2)}`;
      return `+${digits.slice(0, 2)} ${digits.slice(2, 7)} ${digits.slice(7, 13)}`;
    }
  },
  '34': {
    code: '+34',
    name: 'Spain',
    flag: '🇪🇸',
    countryCode: 'es',
    pattern: '+34 XXX XXX XXX',
    maxLength: 12,
    format: (digits: string) => {
      if (digits.length <= 2) return `+${digits}`;
      if (digits.length <= 5) return `+${digits.slice(0, 2)} ${digits.slice(2)}`;
      if (digits.length <= 8) return `+${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5)}`;
      return `+${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5, 8)} ${digits.slice(8, 12)}`;
    }
  },
  '39': {
    code: '+39',
    name: 'Italy',
    flag: '🇮🇹',
    countryCode: 'it',
    pattern: '+39 XXX XXX XXXX',
    maxLength: 13,
    format: (digits: string) => {
      if (digits.length <= 2) return `+${digits}`;
      if (digits.length <= 5) return `+${digits.slice(0, 2)} ${digits.slice(2)}`;
      if (digits.length <= 8) return `+${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5)}`;
      return `+${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5, 8)} ${digits.slice(8, 13)}`;
    }
  },
  '82': {
    code: '+82',
    name: 'South Korea',
    flag: '🇰🇷',
    countryCode: 'kr',
    pattern: '+82 XX XXXX XXXX',
    maxLength: 13,
    format: (digits: string) => {
      if (digits.length <= 2) return `+${digits}`;
      if (digits.length <= 4) return `+${digits.slice(0, 2)} ${digits.slice(2)}`;
      if (digits.length <= 8) return `+${digits.slice(0, 2)} ${digits.slice(2, 4)} ${digits.slice(4)}`;
      return `+${digits.slice(0, 2)} ${digits.slice(2, 4)} ${digits.slice(4, 8)} ${digits.slice(8, 13)}`;
    }
  }
};

export const detectCountryFromNumber = (phoneNumber: string): CountryData | null => {
  const digits = phoneNumber.replace(/\D/g, '');
  
  // Try to match country codes by length (longest first to avoid conflicts)
  const sortedCodes = Object.keys(COUNTRY_CODES).sort((a, b) => b.length - a.length);
  
  for (const code of sortedCodes) {
    if (digits.startsWith(code)) {
      return COUNTRY_CODES[code];
    }
  }
  
  return null;
};

export const formatPhoneNumberInternational = (phoneNumber: string): {
  formatted: string;
  country: CountryData | null;
  isValid: boolean;
} => {
  const digits = phoneNumber.replace(/\D/g, '');
  
  if (digits.length === 0) {
    return { formatted: '', country: null, isValid: false };
  }
  
  const country = detectCountryFromNumber(digits);
  
  if (!country) {
    // Default formatting for unknown countries
    if (digits.length === 1) {
      return { formatted: `+${digits}`, country: null, isValid: false };
    }
    return { formatted: `+${digits}`, country: null, isValid: digits.length >= 7 && digits.length <= 15 };
  }
  
  const formatted = country.format(digits);
  const isValid = digits.length <= country.maxLength && digits.length >= 7;
  
  return { formatted, country, isValid };
};
